import { createTheme } from "@material-ui/core";
import {getTheme, setTheme} from "../utils/storage";

// Identidade Matera v4 — roxo principal como token `primary` propaga
// automaticamente para todos os componentes MUI que o referenciam.
const primary = { main: "#440099" };
// `orange` (MUI default) substituído pelo verde da marca. contrastText em
// roxo escuro (#330072) segue a combinação validada no guia (11.60:1, AA+AAA).
const secondary = { main: "#6BFF50", contrastText: "#330072" };
// `error` do MUI (vermelho padrão) alinhado ao token --cor-erro da marca.
// Propaga para validação de formulário (helper text, borda de input) e
// para os estados de erro de Notification.js/TableSortable/SnackMessage.
const error = { main: "#D92D20" };

export const lightTheme = createTheme({
    typography: {
        useNextVariants: true,
        fontFamily: [
        '"Poppins"',
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
        ].join(","),
    },
    palette: {
        background: { paper: "#fff", default: "#EBEBEB" },
        type: "light",
        primary,
        secondary,
        error,
    },
    background: `url(${process.env.PUBLIC_URL+'/images/backgroundNewLight.png'})`,
});
export const darkTheme = createTheme({
    typography: {
        useNextVariants: true,
        fontFamily: [
            '"Poppins"',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
    },
    palette: {
        type: 'dark',
        primary,
        secondary,
        error,
    },
    background: `url(${process.env.PUBLIC_URL+'/images/backgroundNewDark.png'})`,
});

export default function setThemeReducer(type = getTheme() ? 'dark' : 'light'){
    switch(type){
        case 'light':
            setTheme(false)
            return lightTheme;
        case 'dark':
            setTheme(true)
            return darkTheme;
        default:
            setTheme(false)
            return darkTheme;
    }
}
